/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from '@reduxjs/toolkit';
import entity from 'core/reducers/entities';
import state from 'core/reducers/state';
import session from 'core/slices/session';
import core from 'core/slices/core';
import flow from 'core/slices/flow';
import commands from 'core/slices/commands';
import { InjectedReducersType } from 'utils/types/injector-typings';
import register from 'core/slices/register';
import preview from 'core/slices/preview';
import queue from 'core/slices/queue';
import toasts from 'core/slices/toasts';
import aiModule from 'core/slices/aiModule';
import inspector from 'core/slices/inspector';
import translation from 'core/slices/translation';
/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */

export function createReducer(injectedReducers: InjectedReducersType = {}) {
  return combineReducers({
    ...injectedReducers,
    entity,
    state,
    session,
    register,
    core,
    flow,
    commands,
    preview,
    queue,
    toasts,
    aiModule,
    inspector,
    translation,
  });
}
